// Generated by CoffeeScript 1.6.3
/**
 * 60 FPS (interface smoothness).
 * Inspired from: http://habrahabr.ru/post/204238/
*/

itsoftApp.createModule("pointerEvents", function() {
  var $body, $window, className, removeClass;
  $body = itsoftApp.commonVars.$body;
  $window = itsoftApp.commonVars.$window;
  className = "is-hover-disabled";
  removeClass = itsoftApp.utils.debouncer(function() {
    return $body.removeClass(className);
  });
  return $window.on("scroll", function() {
    $body.addClass(className);
    return removeClass();
  });
});

/*
//@ sourceMappingURL=pointerEvents.map
*/
